import styled from '@emotion/styled';
import PropTypes from 'prop-types';

const Container = styled.section`
  ${({ theme }) => theme.mixins.flexColCenter};
  background-color: ${({ theme, backgroundColor }) =>
    theme.colors[backgroundColor]};
`;

const Content = styled.div`
  width: 100%;
  max-width: ${({ theme }) => theme.layouts.maxWidth};
  padding: clamp(1.25rem, 2vw, 2rem);
`;

const PageSection = ({ id, backgroundColor, children }) => {
  return (
    <Container id={id} backgroundColor={backgroundColor}>
      <Content>{children}</Content>
    </Container>
  );
};

PageSection.propTypes = {
  backgroundColor: PropTypes.string,
  children: PropTypes.array.isRequired,
};

export default PageSection;
